import { BaseModel } from "model/BaseModel";

export default class Transacao implements BaseModel {

    id: number;
    codigo: string | null;
    descricao: string;
    tipo: string;

    constructor(
        id = 0,
        codigo = null,
        descricao = '',
        tipo = '',
    ) {
        this.id = id;
        this.codigo = codigo;
        this.descricao = descricao;
        this.tipo = tipo;
    }
}